const APP_AUTH_STORAGE_KEYS = [
  "email",
  "jobTitle",
  "accessToken",
  "tokenExpiration",
  "loginTime",
  "idToken",
  "organizationId",
  "organizationName",
  "storageAccountName",
  "customerFirstName",
  "selectedCustomerEmail",
  "microgridDesign",
  "selectedSimulation",
  "selectedBranchId",
  "selectedBranchName",
  "timeSeriesFileName",
  "UserID",
];

export function clearLocalAuthState() {
  APP_AUTH_STORAGE_KEYS.forEach((key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // ignore storage failures
    }

    try {
      localStorage.removeItem(key);
    } catch {
      // ignore storage failures
    }
  });
}

